import React from 'react';
import PwaInstallContext from './PwaInstallContext';
import PwaInstallPopupChromium from './PwaInstallPopupChromium';
import PwaInstallPopupIOS from './PwaInstallPopupIOS';

interface PwaInstallPopupProps {
    forceDisplay?: boolean;
}

const PwaInstallPopup: React.FC<PwaInstallPopupProps> = ({
    forceDisplay = false,
}: PwaInstallPopupProps) => (
    <>
        <PwaInstallContext.Provider value={{ deferredPrompt: global.deferredPrompt }}>
            <PwaInstallPopupChromium forceDisplay={forceDisplay} />
        </PwaInstallContext.Provider>
        <PwaInstallPopupIOS forceDisplay={forceDisplay} />
    </>
);

export default PwaInstallPopup;
